import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Az\u0259rbaycanca",
  code: "az",
  messages: {
    alert: {
      close: "Ba\u011Fla"
    },
    authForm: {
      hidePassword: "\u015Eifr\u0259ni gizl\u0259t",
      showPassword: "\u015Eifr\u0259ni g\xF6st\u0259r",
      submit: "Davam et"
    },
    banner: {
      close: "Ba\u011Fla"
    },
    calendar: {
      nextMonth: "N\xF6vb\u0259ti ay",
      nextYear: "N\xF6vb\u0259ti il",
      prevMonth: "\u018Fvv\u0259lki ay",
      prevYear: "\u018Fvv\u0259lki il"
    },
    carousel: {
      dots: "G\xF6st\u0259rm\u0259k \xFC\xE7\xFCn slayd se\xE7in",
      goto: "Slayd {slide} ke\xE7",
      next: "N\xF6vb\u0259ti",
      prev: "\u018Fvv\u0259lki"
    },
    chatPrompt: {
      placeholder: "Buraya mesaj\u0131n\u0131z\u0131 yaz\u0131n..."
    },
    chatPromptSubmit: {
      label: "G\xF6nd\u0259r"
    },
    colorMode: {
      dark: "Qaranl\u0131q",
      light: "\u0130\u015F\u0131ql\u0131",
      switchToDark: "Qaranl\u0131q rejim\u0259 ke\xE7",
      switchToLight: "\u0130\u015F\u0131ql\u0131 rejim\u0259 ke\xE7",
      system: "Sistem"
    },
    commandPalette: {
      back: "Geri",
      close: "Ba\u011Fla",
      noData: "M\u0259lumat yoxdur",
      noMatch: "Uy\u011Fun m\u0259lumat tap\u0131lmad\u0131",
      placeholder: "\u018Fmr daxil edin v\u0259 ya axtar\u0131n..."
    },
    contentSearch: {
      links: "Ba\u011Flant\u0131lar",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "Axtar..."
    },
    contentToc: {
      title: "Bu s\u0259hif\u0259d\u0259"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "Axtar..."
    },
    dashboardSidebarCollapse: {
      collapse: "Yan paneli daralt",
      expand: "Yan paneli geni\u015Fl\u0259t"
    },
    dashboardSidebarToggle: {
      close: "Yan paneli ba\u011Fla",
      open: "Yan paneli a\xE7"
    },
    error: {
      clear: "Ana s\u0259hif\u0259y\u0259 qay\u0131t"
    },
    fileUpload: {
      removeFile: "{filename} sil"
    },
    header: {
      close: "Menyunu ba\u011Fla",
      open: "Menyunu a\xE7"
    },
    inputMenu: {
      create: '"{label}" yarat',
      noData: "M\u0259lumat yoxdur",
      noMatch: "Uy\u011Fun m\u0259lumat tap\u0131lmad\u0131"
    },
    inputNumber: {
      decrement: "Azalt",
      increment: "Art\u0131r"
    },
    modal: {
      close: "Ba\u011Fla"
    },
    pricingTable: {
      caption: "Qiym\u0259t planlar\u0131n\u0131n m\xFCqayis\u0259si"
    },
    prose: {
      codeCollapse: {
        closeText: "Daralt",
        name: "kod",
        openText: "Geni\u015Fl\u0259t"
      },
      collapsible: {
        closeText: "Gizl\u0259t",
        name: "x\xFCsusiyy\u0259tl\u0259r",
        openText: "G\xF6st\u0259r"
      },
      pre: {
        copy: "Kodu bufer\u0259 kopyala"
      }
    },
    selectMenu: {
      create: '"{label}" yarat',
      noData: "M\u0259lumat yoxdur",
      noMatch: "Uy\u011Fun m\u0259lumat tap\u0131lmad\u0131",
      search: "Axtar..."
    },
    slideover: {
      close: "Ba\u011Fla"
    },
    table: {
      noData: "M\u0259lumat yoxdur"
    },
    toast: {
      close: "Ba\u011Fla"
    }
  }
});
